module.exports = __webpack_public_path__ + "static/img/3.0a7b08f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tiankeng/3.jpg
// module id = +mP0
// module chunks = 1